import { IStorageService } from "./storage-service";

export class LocalStorageService<T extends string> implements IStorageService<T> {

    private APP_NAME: string;

    constructor(appName: string) {
        this.APP_NAME = appName;
    }

    clear(): void {
        window.localStorage.clear();
    }

    getLength(): number {
        return window.localStorage.length;
    }

    // key(index: number): string | null {
    //     return window.localStorage.key(index);
    // }

    // 原来的旧键拼法
    private getOldKey(key: T): string {
        const oldKeyPart = this.snakeToPascal(key);
        return `${this.APP_NAME}-${oldKeyPart}`;
    }

    private snakeToPascal(str: string): string {
        return str
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join('');
    }

    // 新键拼法：前缀与 key 片段用 - 连接，key 片段转成小写 kebab_case
    private getNewKey(key: T): string {
        const newKeyPart = this.toKebabCase(key);
        return `${this.APP_NAME}-${newKeyPart}`;
    }

    // PascalCase → kebab_case 并全小写
    private toKebabCase(str: string): string {
        return str
            .replace(/([a-z])([A-Z])/g, '$1_$2')       // aA → a-A
            .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2') // AAa → A-Aa 处理连续大写
            .toLowerCase();
    }

    // 读取：优先读新键，回退到旧键，并自动迁移
    getItem(key: T): string | null {
        const newKey = this.getNewKey(key);
        let value = window.localStorage.getItem(newKey);

        if (value !== null) {
            return value;
        }

        const oldKey = this.getOldKey(key);
        value = window.localStorage.getItem(oldKey);

        if (value !== null) {
            // 迁移数据到新键
            try {
                window.localStorage.setItem(newKey, value);
            } catch (e) {
                // quota 不足等极端情况，静默处理
                console.warn('localStorage migration failed', e);
            }
            // 迁移后是否立即删除旧键？建议保留一段时间，或这里直接删掉
            window.localStorage.removeItem(oldKey);

            return value;
        }

        return null;
    }

    // 写入：只写新键，并顺手清理可能残留的旧键
    setItem(key: T, value: string): void {
        const newKey = this.getNewKey(key);
        window.localStorage.setItem(newKey, value);

        const oldKey = this.getOldKey(key);
        if (window.localStorage.getItem(oldKey) !== null) {
            window.localStorage.removeItem(oldKey);
        }
    }

    // 删除
    removeItem(key: T): void {
        // window.localStorage.removeItem(this.getNewKey(key));
        // window.localStorage.removeItem(this.getOldKey(key));
        window.localStorage.removeItem(`${this.APP_NAME}` + '-' + key);
    }

    // removeAll(): void {
    //     for (const key in window) {
    //         if (key.indexOf(`${this.APP_NAME}-`) > -1) {
    //             window.localStorage.removeItem(key);
    //         }
    //     }
    // }
}